import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { TabNav, TabNavItem } from '../../../../components/ui/tabNav/tabNav.component';

/**
 * Layout shared by the four Tenant Config sections: the section's sub-tab bar
 * above the page the tabs switch between.
 */
export const TenantSection = ({ tabs }: { tabs: TabNavItem[] }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', width: '100%' }}>
    <TabNav tabs={tabs} sub />
    <Box sx={{ flex: 1, minWidth: 0, minHeight: 0, width: '100%' }}>
      <Outlet />
    </Box>
  </Box>
);
